import React, {FC, useRef, useState} from 'react';
import {createStyles, Grid, InputBase, makeStyles, Theme, Typography,} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import {IUserEditState} from '../utils';
import {thousandSeparator} from '../../../BusinessDetails/utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

interface Params {
  mutationVariableName?: keyof IUserEditState;
  name: string;
  value: string | undefined | null;
  placeholder?: string;
  setUserState?: React.Dispatch<React.SetStateAction<IUserEditState>>;
}

const TotalCommission: FC<Params> = (props) => {
  const {
    name,
    value,
    mutationVariableName,
    setUserState,
    placeholder,
  } = props;
  const classes = useStyles();
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value || '');
  const inputRef = useRef<any>(null);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const setFocused = () => {
    setIsEditing(true);
    if (inputRef && inputRef.current) {
      inputRef?.current?.focus();
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    if (mutationVariableName && setUserState) {
      setUserState((prev) => {
        return {
          ...prev,
          [mutationVariableName]: text,
        };
      });
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const inputText = event.target.value;
    setText(inputText);
  };

  return (
    <>
      <Grid item xs={12} sm={2} className={classes.left}>
        <Typography className={classes.label}>{name} :</Typography>
      </Grid>
      <Grid item xs={11} sm={9} className={classes.left}>
        <InputBase
          placeholder={placeholder}
          value={!isEditing ? `${thousandSeparator(text)} €` : text}
          inputRef={inputRef}
          inputProps={{ 'aria-label': 'naked' }}
          className={classes.input}
          classes={{ disabled: classes.disabled }}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {isEditing ? (
          <SaveIcon className={classes.icon} onClick={handleBlur} />
        ) : (
          <EditIcon className={classes.icon} onClick={setFocused} />
        )}
      </Grid>
    </>
  );
};

export default TotalCommission;
